// Including multiple keys for mongo till we migrate to mongod
const VALID_SERVICE_NODES = [
  'elasticsearch',
  'postgresql',
  'cockroachdb',
  'mongodb',
  'mongod',
  'foundationdbcluster',
  'redis',
  'timescaledb',
  'configsvr',
  'shardsvr',
  'mongos',
];

function getSize(node, service) {
  if (service === 'redis') {
    return node.memoryMb;
  }
  return node.diskSizeGb * node.quantity;
}

export default function sortPlansAscending(a, b) {
  const serviceNodeAKey = Object.keys(a.nodes).filter((key) =>
    VALID_SERVICE_NODES.includes(key),
  )[0];
  const serviceNodeBKey = Object.keys(b.nodes).filter((key) =>
    VALID_SERVICE_NODES.includes(key),
  )[0];

  const sizeA = getSize(a.nodes[serviceNodeAKey], serviceNodeAKey);
  const sizeB = getSize(b.nodes[serviceNodeBKey], serviceNodeBKey);

  if (sizeA > sizeB) {
    return 1;
  }
  if (sizeB > sizeA) {
    return -1;
  }
  return 0;
}
